import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
// import './_metronic/assets/css/slider.css';
import './_metronic/assets/css/custom-styling.css';
import './_metronic/assets/css/cp_style.css';
import './styles/tailwind-input.css'

import * as AppRoutes from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {initBackdropSwipeProtection} from './app/shared/utils/preventBackdropSwipeClose'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)
initBackdropSwipeProtection()

const clearInitialSplashState = () => {
  document.body.classList.remove('page-loading', 'splash-screen')
  const splashScreen = document.getElementById('splash-screen')
  if (splashScreen) {
    splashScreen.classList.add('hidden')
    splashScreen.setAttribute('style', 'display: none;')
  }
}

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  clearInitialSplashState()
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes.AppRoutes />
        </AuthProvider>
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}
